export const AUTO_UPDATER_OPEN_DIALOG_EVENT = 'terra:auto-updater-open-dialog';
